// The phase options of a filter, cut down to the ones with something to show (see seasons/{id}/phases):
// key 'leagues' for the standings and the schedule (matches, or a bracket), 'played' for the stats.
// The cup has no phases (the phase of a cup match is ignored): no option at all
export function availablePhases(options, seasonPhases, league, key = 'leagues') {
    if (league === 'Cup') return []
    if (!seasonPhases) return options
    const byLeague = seasonPhases[key] || {}
    // no league chosen: the phases of any league
    const phases = league && league.id !== undefined
        ? byLeague[league.id] || []
        : [].concat(...Object.values(byLeague))
    return options.filter(option => phases.includes(option.value))
}

// the phase to show when the current one is not an option: the preferred one (the active phase), else the
// regular season, else the first; the current one while there is no option
export function pickPhase(current, options, preferred) {
    const values = options.map(option => option.value)
    if (!values.length || values.includes(current)) return current
    if (preferred && values.includes(preferred)) return preferred
    if (values.includes('regular_season')) return 'regular_season'
    return values[0]
}
